/**
 * File generated by js-routes 2.2.10
 * Based on Rails 7.2.2.1 routes of Vesta::Application
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.define_module("ESM", result);
    return result;
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /Tout-savoir-sur-la-taxe-fonciere(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const Tout_savoir_sur_la_taxe_fonciere_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"Tout-savoir-sur-la-taxe-fonciere"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-102m2-75015-paris-b96b54(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_102m2_75015_paris_b96b54_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-102m2-75015-paris-b96b54"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-103m2-75014-paris-8398eb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_103m2_75014_paris_8398eb_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-103m2-75014-paris-8398eb"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-104m2-93200-saint-denis-3a45c0(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_104m2_93200_saint_denis_3a45c0_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-104m2-93200-saint-denis-3a45c0"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-107m2-75009-paris-5f1149(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_107m2_75009_paris_5f1149_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-107m2-75009-paris-5f1149"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-114m2-75018-paris-a3bf32(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_114m2_75018_paris_a3bf32_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-114m2-75018-paris-a3bf32"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-114m2-94130-nogent-sur-marne-634837(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_114m2_94130_nogent_sur_marne_634837_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-114m2-94130-nogent-sur-marne-634837"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-118m2-92100-boulogne-billancourt-cede08(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_118m2_92100_boulogne_billancourt_cede08_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-118m2-92100-boulogne-billancourt-cede08"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-119m2-94300-vincennes-842b50(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_119m2_94300_vincennes_842b50_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-119m2-94300-vincennes-842b50"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-120m2-92100-boulogne-billancourt-cede08(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_120m2_92100_boulogne_billancourt_cede08_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-120m2-92100-boulogne-billancourt-cede08"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-130m2-92000-nanterre-b8e333(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_130m2_92000_nanterre_b8e333_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-130m2-92000-nanterre-b8e333"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-136m2-92120-montrouge-2d4d75(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_136m2_92120_montrouge_2d4d75_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-136m2-92120-montrouge-2d4d75"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-14m2-75018-paris-2a528b(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_14m2_75018_paris_2a528b_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-14m2-75018-paris-2a528b"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-14m2-75018-paris-5ee5ea(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_14m2_75018_paris_5ee5ea_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-14m2-75018-paris-5ee5ea"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-15m2-75019-paris-68445b(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_15m2_75019_paris_68445b_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-15m2-75019-paris-68445b"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-202m2-75116-paris-ad3ec9(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_202m2_75116_paris_ad3ec9_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-202m2-75116-paris-ad3ec9"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-205m2-75016-paris-31e56a(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_205m2_75016_paris_31e56a_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-205m2-75016-paris-31e56a"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-20m2-92110-clichy-230523(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_20m2_92110_clichy_230523_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-20m2-92110-clichy-230523"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-21m2-44000-nantes-1d6393(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_21m2_44000_nantes_1d6393_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-21m2-44000-nantes-1d6393"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-24m2-75005-paris-85d4ba(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_24m2_75005_paris_85d4ba_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-24m2-75005-paris-85d4ba"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-25m2-75005-paris-f4ae16(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_25m2_75005_paris_f4ae16_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-25m2-75005-paris-f4ae16"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-27m2-75013-paris-cc3f44(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_27m2_75013_paris_cc3f44_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-27m2-75013-paris-cc3f44"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-28m2-33000-bordeaux-d17032(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_28m2_33000_bordeaux_d17032_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-28m2-33000-bordeaux-d17032"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-28m2-75014-paris-dbfad9(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_28m2_75014_paris_dbfad9_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-28m2-75014-paris-dbfad9"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-29m2-75018-paris-fc5500(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_29m2_75018_paris_fc5500_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-29m2-75018-paris-fc5500"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-30m2-75013-paris-cce198(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_30m2_75013_paris_cce198_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-30m2-75013-paris-cce198"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-30m2-75017-paris-90445e(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_30m2_75017_paris_90445e_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-30m2-75017-paris-90445e"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-31m2-75013-paris-cf9661(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_31m2_75013_paris_cf9661_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-31m2-75013-paris-cf9661"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-31m2-94200-ivry-sur-seine-073b10(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_31m2_94200_ivry_sur_seine_073b10_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-31m2-94200-ivry-sur-seine-073b10"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-32m2-75013-paris-ab1569(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_32m2_75013_paris_ab1569_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-32m2-75013-paris-ab1569"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-32m2-92100-boulogne-billancourt-a55184(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_32m2_92100_boulogne_billancourt_a55184_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-32m2-92100-boulogne-billancourt-a55184"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-32m2-92800-puteaux-65136f(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_32m2_92800_puteaux_65136f_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-32m2-92800-puteaux-65136f"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-33m2-75006-paris-46c5a3(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_33m2_75006_paris_46c5a3_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-33m2-75006-paris-46c5a3"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-34m2-75015-paris-8be880(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_34m2_75015_paris_8be880_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-34m2-75015-paris-8be880"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-35m2-75020-paris-8b13df(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_35m2_75020_paris_8b13df_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-35m2-75020-paris-8b13df"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-36m2-75013-paris-94e88d(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_36m2_75013_paris_94e88d_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-36m2-75013-paris-94e88d"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-37m2-75012-paris-cf7264(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_37m2_75012_paris_cf7264_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-37m2-75012-paris-cf7264"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-38m2-75018-paris-8b2afb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_38m2_75018_paris_8b2afb_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-38m2-75018-paris-8b2afb"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-39m2-75013-paris-7619de(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_39m2_75013_paris_7619de_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-39m2-75013-paris-7619de"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-42m2-75015-paris-33bddb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_42m2_75015_paris_33bddb_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-42m2-75015-paris-33bddb"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-42m2-92100-boulogne-billancourt-91ee8e(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_42m2_92100_boulogne_billancourt_91ee8e_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-42m2-92100-boulogne-billancourt-91ee8e"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-42m2-92230-gennevilliers-cf3f0f(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_42m2_92230_gennevilliers_cf3f0f_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-42m2-92230-gennevilliers-cf3f0f"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-43m2-69006-lyon-1ac513(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_43m2_69006_lyon_1ac513_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-43m2-69006-lyon-1ac513"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-45m2-75014-paris-572115(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_45m2_75014_paris_572115_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-45m2-75014-paris-572115"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-47m2-75015-paris-5e856a(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_47m2_75015_paris_5e856a_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-47m2-75015-paris-5e856a"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-47m2-75020-paris-a1d5e5(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_47m2_75020_paris_a1d5e5_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-47m2-75020-paris-a1d5e5"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-47m2-93400-saint-ouen-sur-seine-8f91eb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_47m2_93400_saint_ouen_sur_seine_8f91eb_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-47m2-93400-saint-ouen-sur-seine-8f91eb"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-48m2-75019-paris-da0ec1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_48m2_75019_paris_da0ec1_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-48m2-75019-paris-da0ec1"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-49m2-13002-marseille-f0b2f9(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_49m2_13002_marseille_f0b2f9_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-49m2-13002-marseille-f0b2f9"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-49m2-33000-bordeaux-5d4497(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_49m2_33000_bordeaux_5d4497_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-49m2-33000-bordeaux-5d4497"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-50m2-75011-paris-4b26f8(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_50m2_75011_paris_4b26f8_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-50m2-75011-paris-4b26f8"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-50m2-93200-saint-ouen-49a825(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_50m2_93200_saint_ouen_49a825_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-50m2-93200-saint-ouen-49a825"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-52m2-75017-paris-e657a3(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_52m2_75017_paris_e657a3_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-52m2-75017-paris-e657a3"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-53m2-92100-boulogne-billancourt-65b968(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_53m2_92100_boulogne_billancourt_65b968_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-53m2-92100-boulogne-billancourt-65b968"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-54m2-75011-paris-dfc4fb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_54m2_75011_paris_dfc4fb_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-54m2-75011-paris-dfc4fb"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-55m2-75015-paris-5cb412(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_55m2_75015_paris_5cb412_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-55m2-75015-paris-5cb412"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-56m2-75004-paris-4ef1d2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_56m2_75004_paris_4ef1d2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-56m2-75004-paris-4ef1d2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-56m2-75011-paris-7ed8b8(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_56m2_75011_paris_7ed8b8_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-56m2-75011-paris-7ed8b8"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-56m2-75017-paris-1c2d51(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_56m2_75017_paris_1c2d51_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-56m2-75017-paris-1c2d51"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-56m2-92800-puteaux-9b27d0(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_56m2_92800_puteaux_9b27d0_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-56m2-92800-puteaux-9b27d0"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-57m2-75010-paris-07b451(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_57m2_75010_paris_07b451_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-57m2-75010-paris-07b451"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-57m2-75018-paris-731ccf(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_57m2_75018_paris_731ccf_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-57m2-75018-paris-731ccf"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-57m2-93100-montreuil-1db43f(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_57m2_93100_montreuil_1db43f_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-57m2-93100-montreuil-1db43f"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-59m2-75010-paris-0bdaa9(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_59m2_75010_paris_0bdaa9_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-59m2-75010-paris-0bdaa9"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-59m2-75015-paris-7553bc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_59m2_75015_paris_7553bc_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-59m2-75015-paris-7553bc"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-61m2-92210-saint-cloud-c38443(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_61m2_92210_saint_cloud_c38443_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-61m2-92210-saint-cloud-c38443"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-62m2-75013-paris-074a17(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_62m2_75013_paris_074a17_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-62m2-75013-paris-074a17"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-63m2-75003-paris-de59f8(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_63m2_75003_paris_de59f8_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-63m2-75003-paris-de59f8"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-63m2-92210-saint-cloud-49a58c(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_63m2_92210_saint_cloud_49a58c_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-63m2-92210-saint-cloud-49a58c"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-64m2-75015-paris-482eb1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_64m2_75015_paris_482eb1_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-64m2-75015-paris-482eb1"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-65m2-92100-boulogne-billancourt-6461ab(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_65m2_92100_boulogne_billancourt_6461ab_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-65m2-92100-boulogne-billancourt-6461ab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-65m2-92100-boulogne-billancourt-9f41c1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_65m2_92100_boulogne_billancourt_9f41c1_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-65m2-92100-boulogne-billancourt-9f41c1"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-65m2-92350-le-plessis-robinson-21ee41(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_65m2_92350_le_plessis_robinson_21ee41_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-65m2-92350-le-plessis-robinson-21ee41"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-66m2-92700-colombes-953d3b(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_66m2_92700_colombes_953d3b_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-66m2-92700-colombes-953d3b"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-67m2-75011-paris-5afd6d(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_67m2_75011_paris_5afd6d_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-67m2-75011-paris-5afd6d"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-67m2-75020-paris-6e3f4c(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_67m2_75020_paris_6e3f4c_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-67m2-75020-paris-6e3f4c"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-67m2-92100-boulogne-billancourt-98d1d3(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_67m2_92100_boulogne_billancourt_98d1d3_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-67m2-92100-boulogne-billancourt-98d1d3"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-68m2-75018-paris-166c3d(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_68m2_75018_paris_166c3d_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-68m2-75018-paris-166c3d"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-69m2-75020-paris-eb8831(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_69m2_75020_paris_eb8831_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-69m2-75020-paris-eb8831"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-70m2-75019-paris-c769ca(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_70m2_75019_paris_c769ca_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-70m2-75019-paris-c769ca"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-70m2-75020-paris-386c5b(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_70m2_75020_paris_386c5b_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-70m2-75020-paris-386c5b"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-70m2-75020-paris-a18e0a(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_70m2_75020_paris_a18e0a_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-70m2-75020-paris-a18e0a"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-70m2-92000-nanterre-1dca96(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_70m2_92000_nanterre_1dca96_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-70m2-92000-nanterre-1dca96"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-70m2-92500-rueil-malmaison-92c839(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_70m2_92500_rueil_malmaison_92c839_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-70m2-92500-rueil-malmaison-92c839"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-72m2-75003-paris-f64bef(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_72m2_75003_paris_f64bef_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-72m2-75003-paris-f64bef"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-72m2-92300-levallois-perret-c6d6a3(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_72m2_92300_levallois_perret_c6d6a3_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-72m2-92300-levallois-perret-c6d6a3"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-73m2-75003-paris-39267d(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_73m2_75003_paris_39267d_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-73m2-75003-paris-39267d"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-76m2-92410-ville-d-avray-c5d108(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_76m2_92410_ville_d_avray_c5d108_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-76m2-92410-ville-d-avray-c5d108"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-80m2-59800-lille-4eda6a(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_80m2_59800_lille_4eda6a_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-80m2-59800-lille-4eda6a"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-80m2-75012-paris-18ca58(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_80m2_75012_paris_18ca58_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-80m2-75012-paris-18ca58"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-80m2-94160-saint-mande-883889(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_80m2_94160_saint_mande_883889_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-80m2-94160-saint-mande-883889"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-85m2-92400-courbevoie-79b121(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_85m2_92400_courbevoie_79b121_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-85m2-92400-courbevoie-79b121"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-87m2-75020-paris-ec4894(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_87m2_75020_paris_ec4894_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-87m2-75020-paris-ec4894"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-88m2-59800-lille-cf2cf4(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_88m2_59800_lille_cf2cf4_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-88m2-59800-lille-cf2cf4"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-90m2-92380-garches-60f145(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_90m2_92380_garches_60f145_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-90m2-92380-garches-60f145"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-90m2-94160-saint-mande-b5cabd(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_90m2_94160_saint_mande_b5cabd_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-90m2-94160-saint-mande-b5cabd"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-91m2-75011-paris-375e44(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_91m2_75011_paris_375e44_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-91m2-75011-paris-375e44"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-91m2-78430-louveciennes-a34585(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_91m2_78430_louveciennes_a34585_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-91m2-78430-louveciennes-a34585"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-93m2-92360-meudon-la-foret-56a815(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_93m2_92360_meudon_la_foret_56a815_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-93m2-92360-meudon-la-foret-56a815"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-94m2-75011-paris-dff64f(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_94m2_75011_paris_dff64f_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-94m2-75011-paris-dff64f"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-appartement-94m2-92100-boulogne-billancourt-236905(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_appartement_94m2_92100_boulogne_billancourt_236905_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-appartement-94m2-92100-boulogne-billancourt-236905"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-loft_atelier-256m2-92600-asnieres-sur-seine-c10985(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_loft_atelier_256m2_92600_asnieres_sur_seine_c10985_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-loft_atelier-256m2-92600-asnieres-sur-seine-c10985"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-loft_atelier-259m2-69007-lyon-486fb9(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_loft_atelier_259m2_69007_lyon_486fb9_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-loft_atelier-259m2-69007-lyon-486fb9"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-maison-(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_maison__path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-maison-"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-maison-0m2-31100-toulouse-3285c4(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_maison_0m2_31100_toulouse_3285c4_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-maison-0m2-31100-toulouse-3285c4"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-maison-101m2-75019-paris-0cf6b5(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_maison_101m2_75019_paris_0cf6b5_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-maison-101m2-75019-paris-0cf6b5"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-maison-105m2-31100-toulouse-3285c4(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_maison_105m2_31100_toulouse_3285c4_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-maison-105m2-31100-toulouse-3285c4"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-maison-118m2-13016-marseille-32e05e(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_maison_118m2_13016_marseille_32e05e_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-maison-118m2-13016-marseille-32e05e"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-maison-120m2-33700-merignac-bdcd8f(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_maison_120m2_33700_merignac_bdcd8f_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-maison-120m2-33700-merignac-bdcd8f"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-maison-123m2-33400-talence-4ec528(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_maison_123m2_33400_talence_4ec528_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-maison-123m2-33400-talence-4ec528"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-maison-132m2-44400-reze-cb5ee6(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_maison_132m2_44400_reze_cb5ee6_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-maison-132m2-44400-reze-cb5ee6"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-maison-134m2-92700-colombes-e7e5a1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_maison_134m2_92700_colombes_e7e5a1_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-maison-134m2-92700-colombes-e7e5a1"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-maison-136m2-93400-saint-ouen-sur-seine-ecde09(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_maison_136m2_93400_saint_ouen_sur_seine_ecde09_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-maison-136m2-93400-saint-ouen-sur-seine-ecde09"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-maison-140m2-33000-bordeaux-4f2560(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_maison_140m2_33000_bordeaux_4f2560_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-maison-140m2-33000-bordeaux-4f2560"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-maison-140m2-33520-bruges-fe1bf6(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_maison_140m2_33520_bruges_fe1bf6_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-maison-140m2-33520-bruges-fe1bf6"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-maison-151m2-92140-clamart-e2dc17(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_maison_151m2_92140_clamart_e2dc17_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-maison-151m2-92140-clamart-e2dc17"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-maison-75m2-78000-versailles-12db02(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_maison_75m2_78000_versailles_12db02_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-maison-75m2-78000-versailles-12db02"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-maison-86m2-92140-clamart-ecf92d(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_maison_86m2_92140_clamart_ecf92d_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-maison-86m2-92140-clamart-ecf92d"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/vente-parking_spot-10m2-75011-paris-8e34ca(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const a_vente_parking_spot_10m2_75011_paris_8e34ca_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[6,"vente-parking_spot-10m2-75011-paris-8e34ca"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /traitement-offre/:offer_id(.:format)
 * @param {any} offer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_offer_path = /*#__PURE__*/ __jsr.r({"offer_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"traitement-offre"],[2,[7,"/"],[2,[3,"offer_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /achat-immobilier-comment-evaluer-votre-capacite-emprunt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const achat_immobilier_comment_evaluer_votre_capacite_emprunt_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"achat-immobilier-comment-evaluer-votre-capacite-emprunt"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /validation-adresse/:r_slug/:user_id(.:format)
 * @param {any} r_slug
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const address_validation_path = /*#__PURE__*/ __jsr.r({"r_slug":{"r":true},"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"validation-adresse"],[2,[7,"/"],[2,[3,"r_slug"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/act_dates_rollbacks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_act_dates_rollback_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"act_dates_rollbacks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_actions/estimation_files/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_admin_actions_estimation_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_actions"],[2,[7,"/"],[2,[6,"estimation_files"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_actions/estimation_folder_files/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_admin_actions_estimation_folder_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_actions"],[2,[7,"/"],[2,[6,"estimation_folder_files"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_actions/estimation_folders/:estimation_folder_id/sendings(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_admin_actions_estimation_folder_sendings_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_actions"],[2,[7,"/"],[2,[6,"estimation_folders"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"sendings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_actions/mandates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_admin_actions_mandate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_actions"],[2,[7,"/"],[2,[6,"mandates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_actions/sales/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_admin_actions_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_actions"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_actions/sales/:sale_id/pdf_amendments(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_admin_actions_sale_pdf_amendments_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_actions"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"pdf_amendments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_actions/sales/:sale_id/pdf_offers(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_admin_actions_sale_pdf_offers_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_actions"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"pdf_offers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_actions/sign_mandates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_admin_actions_sign_mandate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_actions"],[2,[7,"/"],[2,[6,"sign_mandates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/allocation_settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_allocation_setting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"allocation_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/allocation_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_allocation_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"allocation_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/blog/articles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_blog_article_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/blog/articles/:article_id/publication(.:format)
 * @param {any} article_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_blog_article_publication_path = /*#__PURE__*/ __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"publication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/blog/article_regions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_blog_article_region_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"article_regions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/blog/articles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_blog_articles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/blog/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_blog_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/blog/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_blog_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_partners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_business_partner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_partners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_partners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_business_partners_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_partners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/buyer_alerts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_buyer_alert_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"buyer_alerts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/buyers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_buyers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"buyers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/clients/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_client_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/clients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_clients_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"clients"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer-services/buyers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_customer_services_buyer_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer-services"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer-services/buyers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_customer_services_buyers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer-services"],[2,[7,"/"],[2,[6,"buyers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/customer-services/sellers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_customer_services_sellers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"customer-services"],[2,[7,"/"],[2,[6,"sellers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/demos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_demos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"demos"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/departments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_department_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/departments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_departments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"departments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/estimation_folders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_estimation_folder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"estimation_folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/estimation_folders/:estimation_folder_id/communication(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_estimation_folder_communication_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"estimation_folders"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"communication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/estimation_folders/:estimation_folder_id/reopenings(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_estimation_folder_reopenings_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"estimation_folders"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"reopenings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rdv-experts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_estimation_meeting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rdv-experts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/rdv-experts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_estimation_meetings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"rdv-experts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/eugene_settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_eugene_setting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"eugene_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/experts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_expert_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"experts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/mon-dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_expert_dashboards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mon-dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/fake/fill_sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_fake_fill_sales_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"fake"],[2,[7,"/"],[2,[6,"fill_sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/financial_profiles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_financial_profile_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"financial_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/georges/infos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_georges_sale_infos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/georges/actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_georges_sale_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/georges/warnings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_georges_sale_warning_notices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"warnings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guides/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_guide_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guides/:guide_slug/categories(.:format)
 * @param {any} guide_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_guide_categories_path = /*#__PURE__*/ __jsr.r({"guide_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"guide_slug"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guides/:guide_slug/categories/:slug(.:format)
 * @param {any} guide_slug
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_guide_category_path = /*#__PURE__*/ __jsr.r({"guide_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"guide_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guides/:guide_slug/categories/:category_slug/articles/:slug(.:format)
 * @param {any} guide_slug
 * @param {any} category_slug
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_guide_category_article_path = /*#__PURE__*/ __jsr.r({"guide_slug":{"r":true},"category_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"guide_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_slug"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guides/:guide_slug/categories/:category_slug/articles(.:format)
 * @param {any} guide_slug
 * @param {any} category_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_guide_category_articles_path = /*#__PURE__*/ __jsr.r({"guide_slug":{"r":true},"category_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"guide_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_slug"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guides(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_guides_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guides"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/hosmanians/deactivations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_hosmanians_deactivation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"hosmanians"],[2,[7,"/"],[2,[6,"deactivations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/chasseurs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_hunter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"chasseurs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/chasseurs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_hunters_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"chasseurs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/inside_sales/allocation_settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_inside_sales_allocation_setting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"inside_sales"],[2,[7,"/"],[2,[6,"allocation_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/inside_sales/allocation_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_inside_sales_allocation_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"inside_sales"],[2,[7,"/"],[2,[6,"allocation_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/registre-factures/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registre-factures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/registre-factures(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_invoices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registre-factures"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_invoices_exports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_lead_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads/:lead_id/contact-manager/:id(.:format)
 * @param {any} lead_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_lead_property_lead_path = /*#__PURE__*/ __jsr.r({"lead_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"lead_id"],[2,[7,"/"],[2,[6,"contact-manager"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/log_as/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_log_as_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"log_as"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/log_as/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_log_as_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"log_as"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/mandates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_mandate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mandates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/mandate_amendments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_mandate_amendment_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"mandate_amendments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/registre-mandats/:mandate_id/documents/:id(.:format)
 * @param {any} mandate_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_mandate_document_path = /*#__PURE__*/ __jsr.r({"mandate_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registre-mandats"],[2,[7,"/"],[2,[3,"mandate_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/registre-mandats/:mandate_id/documents(.:format)
 * @param {any} mandate_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_mandate_documents_path = /*#__PURE__*/ __jsr.r({"mandate_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registre-mandats"],[2,[7,"/"],[2,[3,"mandate_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/registre-mandats/:mandate_id/externals(.:format)
 * @param {any} mandate_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_mandate_externals_path = /*#__PURE__*/ __jsr.r({"mandate_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registre-mandats"],[2,[7,"/"],[2,[3,"mandate_id"],[2,[7,"/"],[2,[6,"externals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/registre-mandats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_mandates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registre-mandats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/notaries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_notary_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notaries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/offres/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_offer_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"offres"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/offres/:offer_id/notary(.:format)
 * @param {any} offer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_offer_notary_path = /*#__PURE__*/ __jsr.r({"offer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"offres"],[2,[7,"/"],[2,[3,"offer_id"],[2,[7,"/"],[2,[6,"notary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/offres/:offer_id/notary_clerc(.:format)
 * @param {any} offer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_offer_notary_clerc_path = /*#__PURE__*/ __jsr.r({"offer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"offres"],[2,[7,"/"],[2,[3,"offer_id"],[2,[7,"/"],[2,[6,"notary_clerc"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/offers/:offer_id/users(.:format)
 * @param {any} offer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_offer_offers_users_path = /*#__PURE__*/ __jsr.r({"offer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[3,"offer_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/offres(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_offers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"offres"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/offers/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_offers_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/panels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_panels_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"panels"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/partner/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_partner_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partner"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/partner/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_partner_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partner"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/partner/pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_partner_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partner"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/partner/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_partner_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partner"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/permissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_permissions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/portal_statistics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_portal_statistics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"portal_statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/registre-promesses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_promise_registers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registre-promesses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/prompts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_prompt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"prompts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/prompts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_prompts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"prompts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/advert_generations(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_advert_generations_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"advert_generations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/availabilities(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_availabilities_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"availabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/bookings(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_bookings_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"bookings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/characteristics(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_characteristics_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"characteristics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/condo(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_condo_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"condo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/diffusions(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_diffusions_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"diffusions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/dpe(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_dpe_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"dpe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/interior(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_interior_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"interior"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/key_infos(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_key_infos_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"key_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/contact-manager/:property_lead_id/send_sms(.:format)
 * @param {any} property_lead_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_lead_send_sms_path = /*#__PURE__*/ __jsr.r({"property_lead_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"contact-manager"],[2,[7,"/"],[2,[3,"property_lead_id"],[2,[7,"/"],[2,[6,"send_sms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/contact-manager(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_leads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"contact-manager"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/media(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_media_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"media"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/notes_bd(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_notes_bd_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"notes_bd"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/past_visits(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_past_visits_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"past_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/property_pictures/:id(.:format)
 * @param {any} property_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_property_picture_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"property_pictures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/similar_properties(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_similar_properties_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"similar_properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/visits(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_property_visits_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/regions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_region_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"regions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/regions/:region_id/cities(.:format)
 * @param {any} region_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_region_cities_path = /*#__PURE__*/ __jsr.r({"region_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"regions"],[2,[7,"/"],[2,[3,"region_id"],[2,[7,"/"],[2,[6,"cities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/regions/:region_id/cities/:id(.:format)
 * @param {any} region_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_region_city_path = /*#__PURE__*/ __jsr.r({"region_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"regions"],[2,[7,"/"],[2,[3,"region_id"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/regions/:region_id/cities/:city_id/quarters/:id(.:format)
 * @param {any} region_id
 * @param {any} city_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_region_city_quarter_path = /*#__PURE__*/ __jsr.r({"region_id":{"r":true},"city_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"regions"],[2,[7,"/"],[2,[3,"region_id"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"city_id"],[2,[7,"/"],[2,[6,"quarters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/regions/:region_id/cities/:city_id/quarters(.:format)
 * @param {any} region_id
 * @param {any} city_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_region_city_quarters_path = /*#__PURE__*/ __jsr.r({"region_id":{"r":true},"city_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"regions"],[2,[7,"/"],[2,[3,"region_id"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"city_id"],[2,[7,"/"],[2,[6,"quarters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/regions/:region_id/yanport_city(.:format)
 * @param {any} region_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_region_yanport_city_path = /*#__PURE__*/ __jsr.r({"region_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"regions"],[2,[7,"/"],[2,[3,"region_id"],[2,[7,"/"],[2,[6,"yanport_city"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/regions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_regions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"regions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/restaffings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_restaffing_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"restaffings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/restaffings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_restaffings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"restaffings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_role_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/roles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_roles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_root_path = /*#__PURE__*/ __jsr.r({"subdomain":{"d":"admin"}}, [7,"/"]);

/**
 * Generates rails route to
 * /admin/ventes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/act_dates/:id(.:format)
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_act_date_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"act_dates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/active_buyers/count(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_active_buyers_count_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"active_buyers"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/buyer_alerts(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_buyer_alerts_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"buyer_alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/competitions(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_competitions_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"competitions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/confirm_loan_obtentions/:id(.:format)
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_confirm_loan_obtention_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"confirm_loan_obtentions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/data_expert(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_data_expert_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"data_expert"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/decrease_price_email_generator(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_decrease_price_email_generator_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"decrease_price_email_generator"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/documents/:id(.:format)
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_document_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/documents(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_documents_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/estimations(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_estimations_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"estimations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/experts(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_experts_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"experts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/flatsy(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_flatsy_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"flatsy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/flatsy/messages(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_flatsy_messages_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"flatsy"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/key_locations(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_key_locations_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"key_locations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/key_movements(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_key_movements_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"key_movements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/key_returns(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_key_returns_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"key_returns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/lightshop_property(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_lightshop_property_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"lightshop_property"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/mandate_amendments(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_mandate_amendments_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"mandate_amendments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/mandate_amendments/externals(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_mandate_amendments_externals_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"mandate_amendments"],[2,[7,"/"],[2,[6,"externals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/mandates(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_mandates_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"mandates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/notaires(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_notaries_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"notaires"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/notary(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_notary_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"notary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/notary_clerc(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_notary_clerc_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"notary_clerc"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/notes/:id(.:format)
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_note_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/notes(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_notes_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/offres/:offer_id/manage_offers(.:format)
 * @param {any} sale_id
 * @param {any} offer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_offer_manage_offers_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"offer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"offres"],[2,[7,"/"],[2,[3,"offer_id"],[2,[7,"/"],[2,[6,"manage_offers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/offres(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_offers_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"offres"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/panel_states(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_panel_states_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"panel_states"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/rdv-photos/:id(.:format)
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_photo_meeting_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"rdv-photos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/rdv-photos/:photo_meeting_id/slots(.:format)
 * @param {any} sale_id
 * @param {any} photo_meeting_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_photo_meeting_slots_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"photo_meeting_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"rdv-photos"],[2,[7,"/"],[2,[3,"photo_meeting_id"],[2,[7,"/"],[2,[6,"slots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/rdv-photos(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_photo_meetings_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"rdv-photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/recall_waitings(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_recall_waitings_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"recall_waitings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales/reopenings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_reopening_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[6,"reopenings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/reviews/:id(.:format)
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_review_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/reviews/:review_id/follow_up_post_aa_communications(.:format)
 * @param {any} sale_id
 * @param {any} review_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_review_follow_up_post_aa_communications_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"review_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"review_id"],[2,[7,"/"],[2,[6,"follow_up_post_aa_communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/reviews(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_reviews_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/sale_breaks/:id(.:format)
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_sale_break_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"sale_breaks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/sale_breaks(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_sale_breaks_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"sale_breaks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/sale_deaths(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_sale_deaths_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"sale_deaths"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/email_communications/:id(.:format)
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_sale_email_communication_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"email_communications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/email_communications/:sale_email_communication_id/sync_delivery(.:format)
 * @param {any} sale_id
 * @param {any} sale_email_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_sale_email_communication_sync_delivery_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"sale_email_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"email_communications"],[2,[7,"/"],[2,[3,"sale_email_communication_id"],[2,[7,"/"],[2,[6,"sync_delivery"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/email_communications/:sale_email_communication_id/sync_opening(.:format)
 * @param {any} sale_id
 * @param {any} sale_email_communication_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_sale_email_communication_sync_opening_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"sale_email_communication_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"email_communications"],[2,[7,"/"],[2,[3,"sale_email_communication_id"],[2,[7,"/"],[2,[6,"sync_opening"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/email_communications(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_sale_email_communications_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"email_communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/sale_expert_scores(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_sale_expert_scores_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"sale_expert_scores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/invoices(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_sale_invoices_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/sms_communications/:id(.:format)
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_sale_sms_communication_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"sms_communications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/sms_communications(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_sale_sms_communications_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"sms_communications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/sale_visit_guides(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_sale_visit_guides_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"sale_visit_guides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/users/:id(.:format)
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_sales_user_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/users(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_sales_users_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/send_hosman_sign_email/:mandate_id(.:format)
 * @param {any} sale_id
 * @param {any} mandate_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_send_hosman_sign_email_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"mandate_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"send_hosman_sign_email"],[2,[7,"/"],[2,[3,"mandate_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/send_main_signer/:mandate_id(.:format)
 * @param {any} sale_id
 * @param {any} mandate_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_send_main_signer_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"mandate_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"send_main_signer"],[2,[7,"/"],[2,[3,"mandate_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/admin-sms-advert(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_send_sms_buyer_adverts_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"admin-sms-advert"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/admin-sms-similar-advert(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_send_sms_buyer_similar_adverts_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"admin-sms-similar-advert"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/sponsorship_sms(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_sponsorship_sms_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"sponsorship_sms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/state_changes(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_state_changes_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"state_changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sale_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sale_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/ubiflow(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_ubiflow_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"ubiflow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/visit_guides/:id(.:format)
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_visit_guide_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"visit_guides"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/visit_guides/:visit_guide_id/reviews(.:format)
 * @param {any} sale_id
 * @param {any} visit_guide_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_visit_guide_reviews_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"visit_guide_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"visit_guides"],[2,[7,"/"],[2,[3,"visit_guide_id"],[2,[7,"/"],[2,[6,"reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/visit_guides(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_visit_guides_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"visit_guides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/yousign_signatories(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sale_yousign_signatories_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"yousign_signatories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sales_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales_healths/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sales_health_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales_healths"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales_teams/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sales_team_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales_teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sales_teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sales_teams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sales_teams"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin-buyer-alert(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_send_sms_buyer_alerts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin-buyer-alert"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sidekiq_web_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"sidekiq"]]]]);

/**
 * Generates rails route to
 * /admin/ventes/sign_members/:sign_member_id/sending(.:format)
 * @param {any} sign_member_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sign_member_sending_path = /*#__PURE__*/ __jsr.r({"sign_member_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[6,"sign_members"],[2,[7,"/"],[2,[3,"sign_member_id"],[2,[7,"/"],[2,[6,"sending"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/statistics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_statistics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/suspensive_conditions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_suspensive_condition_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"suspensive_conditions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboard-equipe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_team_dashboards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard-equipe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/team_members/:team_member_id/availability(.:format)
 * @param {any} team_member_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_team_member_availability_path = /*#__PURE__*/ __jsr.r({"team_member_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[3,"team_member_id"],[2,[7,"/"],[2,[6,"availability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/team_members(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_team_members_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"team_members"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/trix/images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_trix_images_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"trix"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/two_factors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_two_factor_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"two_factors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/two_factors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_two_factors_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"two_factors"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/user_permissions/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_user_permission_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"user_permissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/user_permissions(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_user_permissions_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"user_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/hosman_guides(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_hosman_guides_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"hosman_guides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users_solicitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_solicitations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users_solicitations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/visits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_visit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/visits/:visit_id/guide_visit(.:format)
 * @param {any} visit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_visit_guide_visit_path = /*#__PURE__*/ __jsr.r({"visit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"visit_id"],[2,[7,"/"],[2,[6,"guide_visit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/visits/:visit_id/kinds(.:format)
 * @param {any} visit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_visit_kinds_path = /*#__PURE__*/ __jsr.r({"visit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"visit_id"],[2,[7,"/"],[2,[6,"kinds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/visits/:visit_id/prequalifications(.:format)
 * @param {any} visit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_visit_prequalifications_path = /*#__PURE__*/ __jsr.r({"visit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"visit_id"],[2,[7,"/"],[2,[6,"prequalifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/visit_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_visit_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"visit_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/visits/:visit_id/reports(.:format)
 * @param {any} visit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_visit_reports_path = /*#__PURE__*/ __jsr.r({"visit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"visit_id"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/visits/:visit_id/sms_to_visitor(.:format)
 * @param {any} visit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_visit_sms_to_visitor_path = /*#__PURE__*/ __jsr.r({"visit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"visit_id"],[2,[7,"/"],[2,[6,"sms_to_visitor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/visits/confirmations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_visits_confirmation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[6,"confirmations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/visits/executions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_visits_execution_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[6,"executions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vouchers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_voucher_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vouchers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vouchers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_vouchers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vouchers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/welcome_freelances(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_welcome_freelances_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"welcome_freelances"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/yousign_signatories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_yousign_signatory_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"yousign_signatories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_zone_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_zones_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones/buyers/pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_zones_buyers_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones/buyers/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_zones_buyers_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones/buyers_typology/pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_zones_buyers_typology_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"buyers_typology"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones/buyers_typology/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_zones_buyers_typology_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"buyers_typology"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones/sellers/pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_zones_sellers_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones/sellers/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_zones_sellers_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /a/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adverts_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /after_diag_payment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const after_diag_payment_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"after_diag_payment"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /agence-immobiliere(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agence_immobiliere_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agence-immobiliere"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /agence-immobiliere-nouvelle-generation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agence_immobiliere_nouvelle_generation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agence-immobiliere-nouvelle-generation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ambassadeurs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ambassadeurs_new_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ambassadeurs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /annonces(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const annonces_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"annonces"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /apercu-dossier-estim/:estimation_folder_id(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apercu_dossier_estim_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{},"subdomain":{"d":"admin"}}, [2,[7,"/"],[2,[6,"apercu-dossier-estim"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/availabilities/fetch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_availabilities_fetch_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"availabilities"],[2,[7,"/"],[2,[6,"fetch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/availabilities/update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_availabilities_update_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"availabilities"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/blog/articles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_blog_articles_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buyer_alerts/:buyer_alert_id/corresponding_properties(.:format)
 * @param {any} buyer_alert_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_buyer_alert_corresponding_properties_path = /*#__PURE__*/ __jsr.r({"buyer_alert_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buyer_alerts"],[2,[7,"/"],[2,[3,"buyer_alert_id"],[2,[7,"/"],[2,[6,"corresponding_properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buyer_alerts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_buyer_alerts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buyer_alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buyer_alerts/properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_buyer_alerts_properties_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buyer_alerts"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buyer_alerts/validations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_buyer_alerts_validations_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buyer_alerts"],[2,[7,"/"],[2,[6,"validations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/cities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_cities_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"cities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/cities/:city_id/geo_data(.:format)
 * @param {any} city_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_city_geo_data_path = /*#__PURE__*/ __jsr.r({"city_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"city_id"],[2,[7,"/"],[2,[6,"geo_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/properties/coordinates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_coordinates_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[6,"coordinates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buyers/:customer_id/buyer_alerts/:id(.:format)
 * @param {any} customer_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_buyer_alert_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"buyer_alerts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buyers/:customer_id/buyer_alerts(.:format)
 * @param {any} customer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_buyer_alerts_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"buyer_alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buyers/:customer_id/contacts(.:format)
 * @param {any} customer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_contacts_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sellers/:customer_id/mandates/:id(.:format)
 * @param {any} customer_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_mandate_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"mandates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sellers/:customer_id/mandates/:mandate_id/e_signs(.:format)
 * @param {any} customer_id
 * @param {any} mandate_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_mandate_e_signs_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"mandate_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"mandates"],[2,[7,"/"],[2,[3,"mandate_id"],[2,[7,"/"],[2,[6,"e_signs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buyers/:customer_id/offers/:id(.:format)
 * @param {any} customer_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_offer_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buyers/:customer_id/offers(.:format)
 * @param {any} customer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_offers_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"offers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sellers/:customer_id/properties/:id(.:format)
 * @param {any} customer_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_property_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sellers/:customer_id/sales/:id(.:format)
 * @param {any} customer_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_sale_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buyers/:customer_id/sales/:sale_id/documents(.:format)
 * @param {any} customer_id
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_sale_documents_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"sale_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sellers/:customer_id/sales/:sale_id/publication_data(.:format)
 * @param {any} customer_id
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_sale_publication_data_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"sale_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"publication_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sellers/:customer_id/sales/:sale_id/sales_users/:id(.:format)
 * @param {any} customer_id
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_sale_sales_user_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"sale_id":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"sales_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sellers/:customer_id/sales/:sale_id/sales_users(.:format)
 * @param {any} customer_id
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_sale_sales_users_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"sale_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"sales_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buyers/:customer_id/sales(.:format)
 * @param {any} customer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_sales_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/customers/:customer_id/sponsorships(.:format)
 * @param {any} customer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_sponsorships_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"sponsorships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/buyers/:customer_id/visits(.:format)
 * @param {any} customer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_customer_visits_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[3,"customer_id"],[2,[7,"/"],[2,[6,"visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/documents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_document_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/document_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_document_types_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"document_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/estimation_folders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_estimation_folder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"estimation_folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/estimation_folders/:estimation_folder_id/comparable_sales(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_estimation_folder_comparable_sales_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"estimation_folders"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"comparable_sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/estimation_folders/:estimation_folder_id/similar_sale_screenshots(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_estimation_folder_similar_sale_screenshots_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"estimation_folders"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"similar_sale_screenshots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/estimation_folders/:estimation_folder_id/yanport_similar_properties(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_estimation_folder_yanport_similar_properties_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"estimation_folders"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"yanport_similar_properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/estimation_meetings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_estimation_meeting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"estimation_meetings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/estimations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_estimations_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"estimations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/estimations/experts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_estimations_experts_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"estimations"],[2,[7,"/"],[2,[6,"experts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/buyer_alerts/:buyer_alert_id/subscriptions(.:format)
 * @param {any} buyer_alert_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_buyer_alert_subscriptions_path = /*#__PURE__*/ __jsr.r({"buyer_alert_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"buyer_alerts"],[2,[7,"/"],[2,[3,"buyer_alert_id"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/buyer_alerts/:buyer_alert_id/unsubscriptions(.:format)
 * @param {any} buyer_alert_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_buyer_alert_unsubscriptions_path = /*#__PURE__*/ __jsr.r({"buyer_alert_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"buyer_alerts"],[2,[7,"/"],[2,[3,"buyer_alert_id"],[2,[7,"/"],[2,[6,"unsubscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/comparable_sales/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_comparable_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"comparable_sales"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/estimation_folders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_estimation_folder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"estimation_folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/estimation_folders/:estimation_folder_id/comparable_sales(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_estimation_folder_comparable_sales_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"estimation_folders"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"comparable_sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/estimation_folders/:estimation_folder_id/property_picture(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_estimation_folder_property_picture_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"estimation_folders"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"property_picture"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/estimation_folders/:estimation_folder_id/similar_sale_screenshots(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_estimation_folder_similar_sale_screenshots_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"estimation_folders"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"similar_sale_screenshots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/estimation_folders/:estimation_folder_id/yanport_data(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_estimation_folder_yanport_data_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"estimation_folders"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"yanport_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/estimation_folders/:estimation_folder_id/yanport_dvf_transactions(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_estimation_folder_yanport_dvf_transactions_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"estimation_folders"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"yanport_dvf_transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/estimations/:estimation_id/meilleurs_agents/valuations(.:format)
 * @param {any} estimation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_estimation_meilleurs_agents_valuations_path = /*#__PURE__*/ __jsr.r({"estimation_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"estimations"],[2,[7,"/"],[2,[3,"estimation_id"],[2,[7,"/"],[2,[6,"meilleurs_agents"],[2,[7,"/"],[2,[6,"valuations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/estimations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_estimations_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"estimations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/expert_map/sales/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_expert_map_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"expert_map"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/expert_map/sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_expert_map_sales_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"expert_map"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/guides/:guide_id/visits(.:format)
 * @param {any} guide_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_guide_visits_path = /*#__PURE__*/ __jsr.r({"guide_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"guide_id"],[2,[7,"/"],[2,[6,"visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/guides(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_guides_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"guides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/guides/guide_visits/:visit_id/executions(.:format)
 * @param {any} visit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_guides_guide_visit_executions_path = /*#__PURE__*/ __jsr.r({"visit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[6,"guide_visits"],[2,[7,"/"],[2,[3,"visit_id"],[2,[7,"/"],[2,[6,"executions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/guides/visits/:visit_id/executions(.:format)
 * @param {any} visit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_guides_visit_executions_path = /*#__PURE__*/ __jsr.r({"visit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"visit_id"],[2,[7,"/"],[2,[6,"executions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/guides/visit_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_guides_visit_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[6,"visit_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/guides/visits/:visit_id/reschedules(.:format)
 * @param {any} visit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_guides_visit_reschedules_path = /*#__PURE__*/ __jsr.r({"visit_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"visit_id"],[2,[7,"/"],[2,[6,"reschedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/hosmanians(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_hosmanians_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"hosmanians"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/me/user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_me_user_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/meilleurs_agents/valuations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_meilleurs_agents_valuation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"meilleurs_agents"],[2,[7,"/"],[2,[6,"valuations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/property_highlights(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_property_highlights_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"property_highlights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/quarters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_quarter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"quarters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/sales/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/sales/:sale_id/quarters/:quarter_id/experts(.:format)
 * @param {any} sale_id
 * @param {any} quarter_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_sale_quarter_experts_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"quarter_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"quarters"],[2,[7,"/"],[2,[3,"quarter_id"],[2,[7,"/"],[2,[6,"experts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/sales/verifications/:unique_hash(.:format)
 * @param {any} unique_hash
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_sales_verification_path = /*#__PURE__*/ __jsr.r({"unique_hash":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[6,"verifications"],[2,[7,"/"],[2,[3,"unique_hash"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/similar_sale_screenshots/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_similar_sale_screenshot_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"similar_sale_screenshots"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/users/:user_id/all_unsubscribe(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_user_all_unsubscribe_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"all_unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/users/:user_id/buyer_alerts(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_user_buyer_alerts_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"buyer_alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/users/:user_id/sales(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_user_sales_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/users/:user_id/sales_interests(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_user_sales_interests_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"sales_interests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/users/:user_id/unavailabilities(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_user_unavailabilities_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"unavailabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_users_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/visits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_visit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/eugene/visits/cancel_reasons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_eugene_visits_cancel_reasons_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"eugene"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[6,"cancel_reasons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/experts/:expert_id/reviews(.:format)
 * @param {any} expert_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_expert_reviews_path = /*#__PURE__*/ __jsr.r({"expert_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"experts"],[2,[7,"/"],[2,[3,"expert_id"],[2,[7,"/"],[2,[6,"reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/fame_reasons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_fame_reasons_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"fame_reasons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/feedbacks/visits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_feedbacks_visit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"feedbacks"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/geo_data/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_geo_datum_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"geo_data"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/dashboard/expert_event_details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_georges_dashboard_expert_event_details_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"expert_event_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/dashboard/expert_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_georges_dashboard_expert_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"expert_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/dashboard/expert_sale_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_georges_dashboard_expert_sale_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"expert_sale_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/dashboard/expert_wallets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_georges_dashboard_expert_wallets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"expert_wallets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/dashboard/experts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_georges_dashboard_experts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"experts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/dashboard/update_disponibilities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_georges_dashboard_update_disponibilities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"update_disponibilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/notification_filters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_georges_notification_filters_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"notification_filters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/sale_infos/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_georges_sale_info_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"sale_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/sale_infos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_georges_sale_infos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"sale_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/sale_subtasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_georges_sale_subtask_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"sale_subtasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/sale_subtasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_georges_sale_subtasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"sale_subtasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/sale_tasks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_georges_sale_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"sale_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/sale_tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_georges_sale_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"sale_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/sale_warning_notices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_georges_sale_warning_notice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"sale_warning_notices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/sale_warning_notices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_georges_sale_warning_notices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"sale_warning_notices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/leads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_leads_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"leads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_login_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_logout_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/partners/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_partner_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/partners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_partners_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"partners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/physical_addresses/:user_id(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_physical_address_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"physical_addresses"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_properties_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/properties/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/properties/:property_id/property_pictures(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_property_property_pictures_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"property_pictures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/properties/:property_id/unavailabilities(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_property_unavailabilities_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"unavailabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/properties/:property_id/visits(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_property_visits_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/quarters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_quarters_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"quarters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/regions/:region_id/geo_data(.:format)
 * @param {any} region_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_region_geo_data_path = /*#__PURE__*/ __jsr.r({"region_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"regions"],[2,[7,"/"],[2,[3,"region_id"],[2,[7,"/"],[2,[6,"geo_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sales/:sale_unique_hash/buyer_alerts(.:format)
 * @param {any} sale_unique_hash
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_sale_buyer_alerts_path = /*#__PURE__*/ __jsr.r({"sale_unique_hash":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"sale_unique_hash"],[2,[7,"/"],[2,[6,"buyer_alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sales/:sale_unique_hash/estimation_results(.:format)
 * @param {any} sale_unique_hash
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_sale_estimation_results_path = /*#__PURE__*/ __jsr.r({"sale_unique_hash":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"sale_unique_hash"],[2,[7,"/"],[2,[6,"estimation_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sales/:sale_id/photo_meetings(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_sale_photo_meetings_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"photo_meetings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sales/:sale_id/photo_meetings/slots(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_sale_photo_meetings_slots_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"photo_meetings"],[2,[7,"/"],[2,[6,"slots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sales/:sale_id/photo_packs(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_sale_photo_packs_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"photo_packs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sales/photo_packs/:sale_id(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_sales_photo_pack_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[6,"photo_packs"],[2,[7,"/"],[2,[3,"sale_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sellers/users/:customer_id(.:format)
 * @param {any} customer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_sellers_user_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"customer_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_sessions_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/slacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_slacks_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"slacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/uploaders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_uploaders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"uploaders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/:customer_id(.:format)
 * @param {any} customer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_user_path = /*#__PURE__*/ __jsr.r({"customer_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"customer_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/user_informations/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_user_information_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user_informations"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/valuations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_valuation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"valuations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/visits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_visit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/visits/verify_infos(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_visits_verify_infos_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[6,"verify_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/vouchers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_vouchers_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"vouchers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/yanport_app/regions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_yanport_app_region_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"yanport_app"],[2,[7,"/"],[2,[6,"regions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/yanport_app/regions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_yanport_app_regions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"yanport_app"],[2,[7,"/"],[2,[6,"regions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/yanport_properties/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_yanport_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"yanport_properties"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const app_root_path = /*#__PURE__*/ __jsr.r({"subdomain":{"d":"app"}}, [7,"/"]);

/**
 * Generates rails route to
 * /attachinary
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachinary_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"attachinary"]]);

/**
 * Generates rails route to
 * /attachinary/cors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachinary_cors_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[2,[2,[7,"/"],[6,"attachinary"]],[7,"/"]],[2,[6,"cors"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /barometers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const barometers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"barometers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /blog/Anne-Claire-head-of-ops-chez-Hosman(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_Anne_Claire_head_of_ops_chez_Hosman_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"Anne-Claire-head-of-ops-chez-Hosman"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/Christophe-developer-full-stack-chez-Hosman(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_Christophe_developer_full_stack_chez_Hosman_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"Christophe-developer-full-stack-chez-Hosman"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/Donner-conge-a-un-locataire-pour-vendre-son-bien(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_Donner_conge_a_un_locataire_pour_vendre_son_bien_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"Donner-conge-a-un-locataire-pour-vendre-son-bien"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/Investissement-immobilier-locatif-comment-calculer-la-rentabilite-locative(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_Investissement_immobilier_locatif_comment_calculer_la_rentabilite_locative_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"Investissement-immobilier-locatif-comment-calculer-la-rentabilite-locative"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/La-proptech-vue-par-les-Francais-L-intelligence-artificielle-au-service-de-l-I-Agent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_La_proptech_vue_par_les_Francais_L_intelligence_artificielle_au_service_de_l_I_Agent_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"La-proptech-vue-par-les-Francais-L-intelligence-artificielle-au-service-de-l-I-Agent"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/Laure-expert-immobilier-chez-Hosman(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_Laure_expert_immobilier_chez_Hosman_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"Laure-expert-immobilier-chez-Hosman"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/Sept-raisons-de-vendre-avec-la-neo-agence-immobiliere-hosman(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_Sept_raisons_de_vendre_avec_la_neo_agence_immobiliere_hosman_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"Sept-raisons-de-vendre-avec-la-neo-agence-immobiliere-hosman"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_article_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_articles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /blog/autre-solution-pret-relais(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_autre_solution_pret_relais_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"autre-solution-pret-relais"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/autres-solutions-pret-relais(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_autres_solutions_pret_relais_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"autres-solutions-pret-relais"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/bilan-immobilier-projections-2023-France(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_bilan_immobilier_projections_2023_France_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"bilan-immobilier-projections-2023-France"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/categories/guide-acheteur(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_categories_guide_acheteur_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"guide-acheteur"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blog/categories/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_category_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blog/corona-et-immobilier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_corona_et_immobilier_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"corona-et-immobilier"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/credit-immobilier-(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_credit_immobilier__path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"credit-immobilier-"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/dpe-aides-a-la-renovation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_dpe_aides_a_la_renovation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"dpe-aides-a-la-renovation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/energie-verte-(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_energie_verte__path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"energie-verte-"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/estimation-bien-immobilier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_estimation_bien_immobilier_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"estimation-bien-immobilier"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/estimation-immobiliere-fixer-le-bon-prix-de-vente(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_estimation_immobiliere_fixer_le_bon_prix_de_vente_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"estimation-immobiliere-fixer-le-bon-prix-de-vente"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/hausse-taux-emprunt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_hausse_taux_emprunt_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"hausse-taux-emprunt"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/immobilier-ces-elements-qui-font-chuter-le-prix-de-votre-bien(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_immobilier_ces_elements_qui_font_chuter_le_prix_de_votre_bien_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"immobilier-ces-elements-qui-font-chuter-le-prix-de-votre-bien"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/juillet_nouveau_DPE(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_juillet_nouveau_DPE_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"juillet_nouveau_DPE"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/la-rentree-Hosman(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_la_rentree_Hosman_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"la-rentree-Hosman"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/pret-relai(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_pret_relai_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"pret-relai"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/prixm2-Lille-immobilier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_prixm2_Lille_immobilier_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"prixm2-Lille-immobilier"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/prixm2-Nantes-immobilier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_prixm2_Nantes_immobilier_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"prixm2-Nantes-immobilier"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/prixm2-lille-immobilier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_prixm2_lille_immobilier_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"prixm2-lille-immobilier"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/prixm2-nantes-immobilier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_prixm2_nantes_immobilier_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"prixm2-nantes-immobilier"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/resilier-mandat-exclusif(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_resilier_mandat_exclusif_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"resilier-mandat-exclusif"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/retrospective-(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_retrospective__path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"retrospective-"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/recherche(/:query)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_search_articles_path = /*#__PURE__*/ __jsr.r({"query":{},"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"recherche"],[2,[1,[2,[7,"/"],[3,"query"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /blog/situation-marche-immobilier-lyonnais(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_situation_marche_immobilier_lyonnais_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"situation-marche-immobilier-lyonnais"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/taux-pret-immobilier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_taux_pret_immobilier_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"taux-pret-immobilier"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/vendre-entre-particulier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blog_vendre_entre_particulier_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"vendre-entre-particulier"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:property_slug/reservation-visite/success/:visit_id(.:format)
 * @param {any} property_slug
 * @param {any} visit_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookings_confirmations_path = /*#__PURE__*/ __jsr.r({"property_slug":{"r":true},"visit_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"property_slug"],[2,[7,"/"],[2,[6,"reservation-visite"],[2,[7,"/"],[2,[6,"success"],[2,[7,"/"],[2,[3,"visit_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:property_slug/reservation-visite/disponibilites(.:format)
 * @param {any} property_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookings_slots_path = /*#__PURE__*/ __jsr.r({"property_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"property_slug"],[2,[7,"/"],[2,[6,"reservation-visite"],[2,[7,"/"],[2,[6,"disponibilites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:property_slug/reservation-visite/informations(.:format)
 * @param {any} property_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bookings_visitors_path = /*#__PURE__*/ __jsr.r({"property_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"property_slug"],[2,[7,"/"],[2,[6,"reservation-visite"],[2,[7,"/"],[2,[6,"informations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /acheter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"acheter"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /alerte-achats/:user_slug/:id(.:format)
 * @param {any} user_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_alert_path = /*#__PURE__*/ __jsr.r({"user_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"alerte-achats"],[2,[7,"/"],[2,[3,"user_slug"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /alerte-achat(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_alert_creator_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"alerte-achat"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /buyer_alerts/:buyer_alert_id/abonnement(.:format)
 * @param {any} buyer_alert_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_alert_subscription_path = /*#__PURE__*/ __jsr.r({"buyer_alert_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"buyer_alerts"],[2,[7,"/"],[2,[3,"buyer_alert_id"],[2,[7,"/"],[2,[6,"abonnement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /buyer_alerts/:user_slug/abonnement(.:format)
 * @param {any} user_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_alerts_subscribed_all_path = /*#__PURE__*/ __jsr.r({"user_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"buyer_alerts"],[2,[7,"/"],[2,[3,"user_slug"],[2,[7,"/"],[2,[6,"abonnement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /buyer_alerts/:user_slug/desabonnement(.:format)
 * @param {any} user_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_alerts_unsubscribed_all_path = /*#__PURE__*/ __jsr.r({"user_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"buyer_alerts"],[2,[7,"/"],[2,[3,"user_slug"],[2,[7,"/"],[2,[6,"desabonnement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ea/alertes-achat(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_buyer_alerts_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ea"],[2,[7,"/"],[2,[6,"alertes-achat"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ea/parrainage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_customer_sponsorships_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ea"],[2,[7,"/"],[2,[6,"parrainage"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ea/interests/:sale_id(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_interest_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ea"],[2,[7,"/"],[2,[6,"interests"],[2,[7,"/"],[2,[3,"sale_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ea/interests/:sale_id/contacts(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_interest_contacts_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ea"],[2,[7,"/"],[2,[6,"interests"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ea/interests/:sale_id/documents(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_interest_documents_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ea"],[2,[7,"/"],[2,[6,"interests"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ea/interests/:sale_id/mes-offres(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_interest_offers_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ea"],[2,[7,"/"],[2,[6,"interests"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"mes-offres"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ea/interests/:sale_id/le-bien(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_interest_property_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ea"],[2,[7,"/"],[2,[6,"interests"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"le-bien"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ea/interests/:sale_id/mes-visites(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_interest_visites_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ea"],[2,[7,"/"],[2,[6,"interests"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"mes-visites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ea/interests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_interests_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ea"],[2,[7,"/"],[2,[6,"interests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /achat-noszones(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buyer_zones_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"achat-noszones"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:id/cancel_future_visits(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_future_visits_admin_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_future_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cgu(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cgu_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cgu"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /prix-immobilier-m2/:region_name/:city_slug(.:format)
 * @param {any} region_name
 * @param {any} city_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cities_geo_data_path = /*#__PURE__*/ __jsr.r({"region_name":{"r":true},"city_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"prix-immobilier-m2"],[2,[7,"/"],[2,[3,"region_name"],[2,[7,"/"],[2,[3,"city_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /coming-soon(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coming_soon_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"coming-soon"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /contact/:contact_request_id/confirmation(.:format)
 * @param {any} contact_request_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_request_confirmation_path = /*#__PURE__*/ __jsr.r({"contact_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contact"],[2,[7,"/"],[2,[3,"contact_request_id"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_requests_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /politique-cookies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cookies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"politique-cookies"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"admin"}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /decouvrir(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decouvrir_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"decouvrir"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/allocation_settings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_allocation_setting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"allocation_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/blog/articles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_blog_article_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/blog/categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_blog_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_partners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_business_partner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/departments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_department_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/estimation_folders/:estimation_folder_id/communication/edit(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_estimation_folder_communication_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"estimation_folders"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"communication"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guides/:slug/edit(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_guide_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guides/:guide_slug/categories/:slug/edit(.:format)
 * @param {any} guide_slug
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_guide_category_path = /*#__PURE__*/ __jsr.r({"guide_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"guide_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guides/:guide_slug/categories/:category_slug/articles/:slug/edit(.:format)
 * @param {any} guide_slug
 * @param {any} category_slug
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_guide_category_article_path = /*#__PURE__*/ __jsr.r({"guide_slug":{"r":true},"category_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"guide_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_slug"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/chasseurs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_hunter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"chasseurs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/inside_sales/allocation_settings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_inside_sales_allocation_setting_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"inside_sales"],[2,[7,"/"],[2,[6,"allocation_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/registre-factures/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registre-factures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads/:lead_id/contact-manager/:id/edit(.:format)
 * @param {any} lead_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_lead_property_lead_path = /*#__PURE__*/ __jsr.r({"lead_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"lead_id"],[2,[7,"/"],[2,[6,"contact-manager"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/registre-mandats/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_mandate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registre-mandats"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/offres/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_offer_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"offres"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/offers/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_offers_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/partner/categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_partner_category_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partner"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/partner/pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_partner_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partner"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/prompts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_prompt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"prompts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/diffusions/edit(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_property_diffusions_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"diffusions"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/regions/:region_id/cities/:id/edit(.:format)
 * @param {any} region_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_region_city_path = /*#__PURE__*/ __jsr.r({"region_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"regions"],[2,[7,"/"],[2,[3,"region_id"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/regions/:region_id/cities/:city_id/quarters/:id/edit(.:format)
 * @param {any} region_id
 * @param {any} city_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_region_city_quarter_path = /*#__PURE__*/ __jsr.r({"region_id":{"r":true},"city_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"regions"],[2,[7,"/"],[2,[3,"region_id"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[3,"city_id"],[2,[7,"/"],[2,[6,"quarters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/restaffings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_restaffing_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"restaffings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/roles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_role_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/notes/:id/edit(.:format)
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_sale_note_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/reviews/:id/edit(.:format)
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_sale_review_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/users/:id/edit(.:format)
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_sale_sales_user_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/visits/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_visit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"visits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/visit_reports/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_visit_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"visit_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vouchers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_voucher_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vouchers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_zone_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones/buyers/pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_zones_buyers_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones/buyers_typology/pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_zones_buyers_typology_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"buyers_typology"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones/sellers/pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_zones_sellers_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /alerte-achats/:user_slug/:id/edit(.:format)
 * @param {any} user_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_buyer_alert_path = /*#__PURE__*/ __jsr.r({"user_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"alerte-achats"],[2,[7,"/"],[2,[3,"user_slug"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ventes/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_sales_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /estimation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimation_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"estimation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /estimation/adresse(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimation_address_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"estimation"],[2,[7,"/"],[2,[6,"adresse"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /estimation/contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimation_contact_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"estimation"],[2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /estimation-immobiliere-agence(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimation_immobiliere_agence_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"estimation-immobiliere-agence"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /estimation-immobiliere-en-ligne(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimation_immobiliere_en_ligne_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"estimation-immobiliere-en-ligne"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /estimation/informations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimation_informations_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"estimation"],[2,[7,"/"],[2,[6,"informations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /estimation-rdv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimation_rdv_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"estimation-rdv"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /estimation/motif(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimation_reason_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"estimation"],[2,[7,"/"],[2,[6,"motif"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /estimation/resultat(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimation_result_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"estimation"],[2,[7,"/"],[2,[6,"resultat"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /estimation/specificites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimation_specificities_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"estimation"],[2,[7,"/"],[2,[6,"specificites"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /estimation/typologie(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimation_typology_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"estimation"],[2,[7,"/"],[2,[6,"typologie"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /estimations/flash(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const estimations_flash_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"estimations"],[2,[7,"/"],[2,[6,"flash"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /nos-experts/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const expert_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"nos-experts"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /expert-map(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const expert_map_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"admin"}}, [2,[7,"/"],[2,[6,"expert-map"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /nos-experts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const experts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"nos-experts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/notes/:id/favorite(.:format)
 * @param {any} sale_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const favorite_admin_sale_note_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"favorite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /financial_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"financial_data"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /flatsy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flatsy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"flatsy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /prix-immobilier-m2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const geo_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"prix-immobilier-m2"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /guides/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guide_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guide_article_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:guide_article_slug/share(.:format)
 * @param {any} guide_article_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guide_article_share_path = /*#__PURE__*/ __jsr.r({"guide_article_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"guide_article_slug"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /guide-categories/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guide_category_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"guide-categories"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /guide-du-vendeur(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guide_du_vendeur_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"guide-du-vendeur"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /vente-rapide(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ibuying_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vente-rapide"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-aucamville(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_aucamville_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-aucamville"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-balma(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_balma_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-balma"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-beauzelle(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_beauzelle_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-beauzelle"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-blagnac(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_blagnac_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-blagnac"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-colomiers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_colomiers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-colomiers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-cugnaux(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_cugnaux_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-cugnaux"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-fenouillet(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_fenouillet_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-fenouillet"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-l-union(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_l_union_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-l-union"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-la-madeleine(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_la_madeleine_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-la-madeleine"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-labege(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_labege_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-labege"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-lambersart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_lambersart_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-lambersart"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-launaguet(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_launaguet_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-launaguet"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-lezennes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_lezennes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-lezennes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-lille(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_lille_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-lille"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-marquette-lez-lille(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_marquette_lez_lille_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-marquette-lez-lille"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-mons-en-baroeul(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_mons_en_baroeul_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-mons-en-baroeul"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-pechbusque(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_pechbusque_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-pechbusque"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-portet-sur-garonne(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_portet_sur_garonne_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-portet-sur-garonne"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-quint-fonsegrives(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_quint_fonsegrives_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-quint-fonsegrives"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-ramonville-saint-agne(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_ramonville_saint_agne_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-ramonville-saint-agne"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-saint-andre-lez-lille(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_saint_andre_lez_lille_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-saint-andre-lez-lille"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-saint-orens-de-gameville(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_saint_orens_de_gameville_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-saint-orens-de-gameville"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-sequedin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_sequedin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-sequedin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-toulouse(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_toulouse_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-toulouse"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-tournefeuille(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_tournefeuille_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-tournefeuille"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/agence-immobiliere-vieille-toulouse(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_agence_immobiliere_vieille_toulouse_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"agence-immobiliere-vieille-toulouse"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lazy_load/trustpilot_reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_load_trustpilot_reviews_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lazy_load"],[2,[7,"/"],[2,[6,"trustpilot_reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lazy_loads/trustpilot_reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lazy_loads_trustpilot_reviews_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lazy_loads"],[2,[7,"/"],[2,[6,"trustpilot_reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lead-confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lead_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead-confirmation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /leads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_new_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads/premium/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_premium_new_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"premium"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lightshop(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lightshop_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lightshop"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /simulateur-emprunt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loan_simulations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"simulateur-emprunt"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/sale_infos/mark_all_infos_as_seen(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_all_infos_as_seen_api_v1_georges_sale_infos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"sale_infos"],[2,[7,"/"],[2,[6,"mark_all_infos_as_seen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mentions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mentions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mentions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /module-estim/:estimation_folder_id/base-acheteur(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const module_estim_buyer_base_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{},"subdomain":{"d":"admin"}}, [2,[7,"/"],[2,[6,"module-estim"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"base-acheteur"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module-estim/:estimation_folder_id/estimation(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const module_estim_estimation_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{},"subdomain":{"d":"admin"}}, [2,[7,"/"],[2,[6,"module-estim"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"estimation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module-estim/:estimation_folder_id/biens-hosman(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const module_estim_hosman_properties_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{},"subdomain":{"d":"admin"}}, [2,[7,"/"],[2,[6,"module-estim"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"biens-hosman"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module-estim/:estimation_folder_id/informations-cles(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const module_estim_key_informations_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{},"subdomain":{"d":"admin"}}, [2,[7,"/"],[2,[6,"module-estim"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"informations-cles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module-estim/:estimation_folder_id/avis(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const module_estim_reviews_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{},"subdomain":{"d":"admin"}}, [2,[7,"/"],[2,[6,"module-estim"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"avis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module-estim/:estimation_folder_id/secteur(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const module_estim_sector_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{},"subdomain":{"d":"admin"}}, [2,[7,"/"],[2,[6,"module-estim"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"secteur"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /module-estim/:estimation_folder_id/biens-comparables(.:format)
 * @param {any} estimation_folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const module_estim_similar_properties_path = /*#__PURE__*/ __jsr.r({"estimation_folder_id":{"r":true},"format":{},"subdomain":{"d":"admin"}}, [2,[7,"/"],[2,[6,"module-estim"],[2,[7,"/"],[2,[3,"estimation_folder_id"],[2,[7,"/"],[2,[6,"biens-comparables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mon-compte(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_account_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"mon-compte"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/admin_actions/sales/:sale_id/pdf_amendments/new(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_admin_actions_sale_pdf_amendment_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_actions"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"pdf_amendments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_actions/sales/:sale_id/pdf_offers/new(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_admin_actions_sale_pdf_offer_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_actions"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"pdf_offers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/allocation_settings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_allocation_setting_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"allocation_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/blog/articles/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_blog_article_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/blog/categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_blog_category_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/business_partners/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_business_partner_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"business_partners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/departments/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_department_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guides/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_guide_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guides/:guide_slug/categories/new(.:format)
 * @param {any} guide_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_guide_category_path = /*#__PURE__*/ __jsr.r({"guide_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"guide_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guides/:guide_slug/categories/:category_slug/articles/new(.:format)
 * @param {any} guide_slug
 * @param {any} category_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_guide_category_article_path = /*#__PURE__*/ __jsr.r({"guide_slug":{"r":true},"category_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"guide_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_slug"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/chasseurs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_hunter_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"chasseurs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/registre-factures/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_invoice_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"registre-factures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/offers/:offer_id/users/new(.:format)
 * @param {any} offer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_offer_offers_user_path = /*#__PURE__*/ __jsr.r({"offer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[3,"offer_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/partner/categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_partner_category_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partner"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/partner/pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_partner_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partner"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/portal_statistics/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_portal_statistic_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"portal_statistics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/contact-manager/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_property_lead_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"contact-manager"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/past_visits/new(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_property_past_visits_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"past_visits"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/regions/:region_id/cities/new(.:format)
 * @param {any} region_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_region_city_path = /*#__PURE__*/ __jsr.r({"region_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"regions"],[2,[7,"/"],[2,[3,"region_id"],[2,[7,"/"],[2,[6,"cities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/restaffings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_restaffing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"restaffings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/mandate_amendments/new(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_sale_mandate_amendments_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"mandate_amendments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/mandates/new(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_sale_mandates_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"mandates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/notes/new(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_sale_note_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/offres/new(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_sale_offer_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"offres"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/rdv-photos/new(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_sale_photo_meeting_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"rdv-photos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/reviews/new(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_sale_review_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/users/new(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_sale_sales_user_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:sale_id/visit_guides/:visit_guide_id/reviews/new(.:format)
 * @param {any} sale_id
 * @param {any} visit_guide_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_sale_visit_guide_review_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"visit_guide_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"visit_guides"],[2,[7,"/"],[2,[3,"visit_guide_id"],[2,[7,"/"],[2,[6,"reviews"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/two_factors/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_two_factor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"two_factors"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/hosman_guides/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_users_hosman_guide_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"hosman_guides"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/vouchers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_voucher_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"vouchers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_zone_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones/buyers/pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_zones_buyers_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"buyers"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones/buyers_typology/pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_zones_buyers_typology_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"buyers_typology"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/zones/sellers/pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_zones_sellers_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"zones"],[2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /alerte-achat/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_buyer_alert_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"alerte-achat"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_contact_request_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /n/:slug/new(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_notaries_property_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"n"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rdv_photo/:mandate_id/new(.:format)
 * @param {any} mandate_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_photo_meeting_path = /*#__PURE__*/ __jsr.r({"mandate_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rdv_photo"],[2,[7,"/"],[2,[3,"mandate_id"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /av/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_post_visit_adverts_property_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"av"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /n/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notaries_properties_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"n"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /n/:slug/:r_slug(.:format)
 * @param {any} slug
 * @param {any} r_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notaries_property_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"r_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"n"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[3,"r_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /nouveau-lead(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nouveau_lead_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"admin"}}, [2,[7,"/"],[2,[6,"nouveau-lead"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /nouveaux-modeles-agences-immobilieres(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nouveaux_modeles_agences_immobilieres_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"nouveaux-modeles-agences-immobilieres"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /nouveaux-tarifs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nouveaux_tarifs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"nouveaux-tarifs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /offer_esign_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offer_esign_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"offer_esign_callback"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /offers/:offer_id/users(.:format)
 * @param {any} offer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offer_users_path = /*#__PURE__*/ __jsr.r({"offer_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[3,"offer_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /offers/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offers_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /offers/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offers_users_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding-vendeur/:mandate_id(.:format)
 * @param {any} mandate_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_sellers_path = /*#__PURE__*/ __jsr.r({"mandate_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"onboarding-vendeur"],[2,[7,"/"],[2,[3,"mandate_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /online_offer/auth/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const online_offer_auth_sign_in_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"online_offer"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /online_offer/buyer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const online_offer_buyer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"online_offer"],[2,[7,"/"],[2,[6,"buyer"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /online_offer/financial_profiles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const online_offer_financial_profile_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"online_offer"],[2,[7,"/"],[2,[6,"financial_profiles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /online_offer/financial_profiles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const online_offer_financial_profiles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"online_offer"],[2,[7,"/"],[2,[6,"financial_profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /online_offer/offers/:property_slug(.:format)
 * @param {any} property_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const online_offer_offer_path = /*#__PURE__*/ __jsr.r({"property_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"online_offer"],[2,[7,"/"],[2,[6,"offers"],[2,[7,"/"],[2,[3,"property_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /online_offer/offers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const online_offer_offers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"online_offer"],[2,[7,"/"],[2,[6,"offers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /online_offer/properties/:property_slug(.:format)
 * @param {any} property_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const online_offer_property_path = /*#__PURE__*/ __jsr.r({"property_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"online_offer"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /online_offer/sign_failures/:offer_id(.:format)
 * @param {any} offer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const online_offer_sign_failure_path = /*#__PURE__*/ __jsr.r({"offer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"online_offer"],[2,[7,"/"],[2,[6,"sign_failures"],[2,[7,"/"],[2,[3,"offer_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /online_offer/sign_successes/:offer_id(.:format)
 * @param {any} offer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const online_offer_sign_success_path = /*#__PURE__*/ __jsr.r({"offer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"online_offer"],[2,[7,"/"],[2,[6,"sign_successes"],[2,[7,"/"],[2,[3,"offer_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /online_offer/signatures/:offer_id(.:format)
 * @param {any} offer_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const online_offer_signature_path = /*#__PURE__*/ __jsr.r({"offer_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"online_offer"],[2,[7,"/"],[2,[6,"signatures"],[2,[7,"/"],[2,[3,"offer_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /remise-offre/:property_slug(/:step_slug)(.:format)
 * @param {any} property_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const online_offers_path = /*#__PURE__*/ __jsr.r({"property_slug":{"r":true},"step_slug":{},"format":{}}, [2,[7,"/"],[2,[6,"remise-offre"],[2,[7,"/"],[2,[3,"property_slug"],[2,[1,[2,[7,"/"],[3,"step_slug"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /departement/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"departement"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/experts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_experts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"experts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_sales_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /parrainage/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const parrainage_new_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"parrainage"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /partner/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const partner_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"partner"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /partner/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const partner_page_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"partner"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /partner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const partner_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"partner"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const personal_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rdv_photo/:mandate_id(.:format)
 * @param {any} mandate_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const photo_meetings_path = /*#__PURE__*/ __jsr.r({"mandate_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rdv_photo"],[2,[7,"/"],[2,[3,"mandate_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pipedrive_activity_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pipedrive_activity_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pipedrive_activity_callback"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pipedrive_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pipedrive_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pipedrive_callback"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pipedrive_notes_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pipedrive_notes_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pipedrive_notes_callback"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pipedrive_person_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pipedrive_person_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pipedrive_person_callback"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /plannings-guides(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plannings_guides_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"admin"}}, [2,[7,"/"],[2,[6,"plannings-guides"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /av(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_visit_adverts_properties_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"av"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /av/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_visit_adverts_property_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"av"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /postmark_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postmark_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"postmark_callback"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /premium(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const premium_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"premium"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /properties/:property_id/annonce(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_annonce_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"annonce"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /properties/:property_id/annonce-suite-a-votre-visite(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_annonce_suite_a_votre_visite_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"annonce-suite-a-votre-visite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:property_slug/demande-de-visite(.:format)
 * @param {any} property_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_leads_path = /*#__PURE__*/ __jsr.r({"property_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"property_slug"],[2,[7,"/"],[2,[6,"demande-de-visite"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /properties/:property_id/visits(.:format)
 * @param {any} property_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const property_visits_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /prix-immobilier-m2/:region_name/:city_slug/:quarter_slug(.:format)
 * @param {any} region_name
 * @param {any} city_slug
 * @param {any} quarter_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const quarters_geo_data_path = /*#__PURE__*/ __jsr.r({"region_name":{"r":true},"city_slug":{"r":true},"quarter_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"prix-immobilier-m2"],[2,[7,"/"],[2,[3,"region_name"],[2,[7,"/"],[2,[3,"city_slug"],[2,[7,"/"],[2,[3,"quarter_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /prix-immobilier-m2/:region_name(.:format)
 * @param {any} region_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regions_geo_data_path = /*#__PURE__*/ __jsr.r({"region_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"prix-immobilier-m2"],[2,[7,"/"],[2,[3,"region_name"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /prix-immobilier-m2/render_faqs_partial(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const render_faqs_partial_geo_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"prix-immobilier-m2"],[2,[7,"/"],[2,[6,"render_faqs_partial"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /prix-immobilier-m2/render_last_property_sold_partial(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const render_last_property_sold_partial_geo_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"prix-immobilier-m2"],[2,[7,"/"],[2,[6,"render_last_property_sold_partial"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /prix-immobilier-m2/render_pricing_quarters_partial(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const render_pricing_quarters_partial_geo_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"prix-immobilier-m2"],[2,[7,"/"],[2,[6,"render_pricing_quarters_partial"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /prix-immobilier-m2/render_pricing_top_cities_partial(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const render_pricing_top_cities_partial_geo_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"prix-immobilier-m2"],[2,[7,"/"],[2,[6,"render_pricing_top_cities_partial"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /prix-immobilier-m2/render_pricing_zones_partial(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const render_pricing_zones_partial_geo_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"prix-immobilier-m2"],[2,[7,"/"],[2,[6,"render_pricing_zones_partial"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /prix-immobilier-m2/render_title_h1_partial(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const render_title_h1_partial_geo_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"prix-immobilier-m2"],[2,[7,"/"],[2,[6,"render_title_h1_partial"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /prix-immobilier-m2/render_title_h2_partial(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const render_title_h2_partial_geo_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"prix-immobilier-m2"],[2,[7,"/"],[2,[6,"render_title_h2_partial"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /prix-immobilier-m2/render_zone_partial(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const render_zone_partial_geo_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"prix-immobilier-m2"],[2,[7,"/"],[2,[6,"render_zone_partial"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resiliation-mandat-exclusif(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resiliation_mandat_exclusif_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resiliation-mandat-exclusif"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resiliation-mandat-vente-exclusifR(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resiliation_mandat_vente_exclusifR_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resiliation-mandat-vente-exclusifR"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /ventes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/georges/sale_tasks/:id/sale_contacts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sale_contacts_api_v1_georges_sale_task_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"georges"],[2,[7,"/"],[2,[6,"sale_tasks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sale_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sale_sliders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sale_sliders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sale_sliders"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ventes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sales_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ventes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ventes/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sales_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /vendre(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sell_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendre"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ev/ventes/:sale_id(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seller_sale_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ev"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ev/ventes/:sale_id/parrainage(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seller_sale_customer_sponsorships_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ev"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"parrainage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ev/ventes/:sale_id/offres(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seller_sale_offers_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ev"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"offres"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ev/ventes/:sale_id/planning(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seller_sale_planning_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ev"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"planning"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ev/ventes/:sale_id/conseils-immo(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seller_sale_ressources_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ev"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"conseils-immo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ev/ventes/:sale_id/dossier-de-vente/documents(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seller_sale_sale_folder_documents_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ev"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"dossier-de-vente"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ev/ventes/:sale_id/dossier-de-vente/infos-du-bien(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seller_sale_sale_folder_property_infos_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ev"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"dossier-de-vente"],[2,[7,"/"],[2,[6,"infos-du-bien"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ev/ventes/:sale_id/dossier-de-vente/archives(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seller_sale_sale_folder_sale_folder_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ev"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"dossier-de-vente"],[2,[7,"/"],[2,[6,"archives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ev/ventes/:sale_id/comptes-rendus(.:format)
 * @param {any} sale_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seller_sale_visit_reports_path = /*#__PURE__*/ __jsr.r({"sale_id":{"r":true},"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ev"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"sale_id"],[2,[7,"/"],[2,[6,"comptes-rendus"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ev/ventes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seller_sales_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"ev"],[2,[7,"/"],[2,[6,"ventes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /trouver-agence-immobiliere(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const seller_zones_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"trouver-agence-immobiliere"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/visit_reports/:id/send_report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_report_admin_visit_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"visit_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /services-tarif(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const services_tarif_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"services-tarif"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sl/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const short_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sl"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sitemap(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sitemap"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /slack_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slack_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"slack_callback"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/roles/:id/spread_permissions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spread_permissions_admin_role_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"spread_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tarifs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tarifs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tarifs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /trustpilot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trustpilot_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"trustpilot"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /achat/:name(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const typology_path = /*#__PURE__*/ __jsr.r({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"achat"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ventes/:id/update_flatsy_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_flatsy_state_admin_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ventes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_flatsy_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/departments/:id/update_position(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_position_admin_department_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"departments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guides/categories/:slug/update_position(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_position_admin_guide_category_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"update_position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guides/:guide_slug/categories/:category_slug/articles/:slug/update_position(.:format)
 * @param {any} guide_slug
 * @param {any} category_slug
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_position_admin_guide_category_article_path = /*#__PURE__*/ __jsr.r({"guide_slug":{"r":true},"category_slug":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"guide_slug"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_slug"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"update_position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/properties/:property_id/property_pictures/:id/update_position(.:format)
 * @param {any} property_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_position_admin_property_property_picture_path = /*#__PURE__*/ __jsr.r({"property_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"properties"],[2,[7,"/"],[2,[3,"property_id"],[2,[7,"/"],[2,[6,"property_pictures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/alerte-achat/:buyer_alert_id/success(.:format)
 * @param {any} user_id
 * @param {any} buyer_alert_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_buyer_alert_confirmations_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"buyer_alert_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"alerte-achat"],[2,[7,"/"],[2,[3,"buyer_alert_id"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /alerte-achats/:user_slug(.:format)
 * @param {any} user_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_buyer_alerts_path = /*#__PURE__*/ __jsr.r({"user_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"alerte-achats"],[2,[7,"/"],[2,[3,"user_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{},"subdomain":{"d":"admin"}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vendre-sans-agence(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vendre_sans_agence_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vendre-sans-agence"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/phones/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_api_v1_phones_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"phones"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /annulation-visite(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const visit_cancelation_path = /*#__PURE__*/ __jsr.r({"format":{},"subdomain":{"d":"app"}}, [2,[7,"/"],[2,[6,"annulation-visite"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:property_slug/demande-de-visite/liste-attente(.:format)
 * @param {any} property_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const waiting_list_success_property_leads_path = /*#__PURE__*/ __jsr.r({"property_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"property_slug"],[2,[7,"/"],[2,[6,"demande-de-visite"],[2,[7,"/"],[2,[6,"liste-attente"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /yousign_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yousign_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"yousign_callback"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /b/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zones_buyers_page_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"b"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /t/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zones_buyers_typology_page_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"t"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zones_sellers_page_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);


